import { useEffect, useRef } from 'react';
import { Box, Flex } from '@optiaxiom/react';
import {
  Background,
  Controls,
  Edge,
  EdgeTypes,
  Node,
  ReactFlow,
  useReactFlow,
} from '@xyflow/react';

import { CustomEdge } from '../edges';
import { useWorkflow } from '../hooks/useWorkflow';

import { styles } from './WorkflowPreviewCanvas.css';

import '@xyflow/react/dist/style.css';

const edgeTypes: EdgeTypes = {
  custom: CustomEdge,
};

export type WorkflowPreviewCanvasProps = {
  nodes: Node[];
  edges: Edge[];
  className?: string;
  showControls?: boolean;
};

export function WorkflowPreviewCanvas({ nodes, edges, className }: WorkflowPreviewCanvasProps) {
  const reactFlowWrapper = useRef<HTMLDivElement>(null);
  const { nodeTypes } = useWorkflow();
  const { fitView: reactFlowFitView } = useReactFlow();

  // Trigger fitView when nodes or edges change (e.g., after save/refetch)
  useEffect(() => {
    if (nodes.length > 0) {
      reactFlowFitView({ padding: 0.2, duration: 200 });
    }
  }, [nodes, edges, reactFlowFitView]);

  return (
    <Box className={className || styles.canvasContainer}>
      <Flex ref={reactFlowWrapper} className={styles.reactFlowWrapper}>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          edgeTypes={edgeTypes}
          proOptions={{
            hideAttribution: true,
          }}
          fitView
          nodesDraggable={false}
          nodesConnectable={false}
          elementsSelectable={false}
          zoomOnScroll={false}
          zoomOnPinch={false}
          panOnDrag={false}
          panOnScroll={false}
          preventScrolling={false}
          className={styles.reactFlow}
          minZoom={0.1}
          maxZoom={4}
        >
          <Background />
          <Controls position="bottom-left" />
        </ReactFlow>
      </Flex>
    </Box>
  );
}
